import { useEffect } from "react";

/**
 * Set the browser tab title for the current page. Restores the previous
 * title on unmount so deep-links don't leave stale titles behind.
 */
export function useTitle(title: string, suffix = "LuzGrid CRM") {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} · ${suffix}` : suffix;
    return () => {
      document.title = prev;
    };
  }, [title, suffix]);
}
